<template>
  <transition name="drawer-fade">
    <div v-if="visible" class="custom-drawer-wrapper">
      <div class="drawer-container" v-loading="submitting" element-loading-text="載入中...">
        <div class="drawer-header">
          <button class="close-btn" @click="handleClose">
            <i class="el-icon-close"></i>
          </button>
          <h4 class="drawer-title">{{ isEditMode ? '編輯客戶資訊' : '新增客戶' }}</h4>
        </div>

        <div class="drawer-content-scroll">
          <el-form ref="form" :model="form" :rules="rules" label-position="top">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="姓名" prop="fullName" required>
                  <el-input v-model="form.fullName" placeholder="請輸入姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label=" " class="gender-item">
                  <el-radio-group v-model="form.gender">
                    <el-radio label="male">先生</el-radio>
                    <el-radio label="female">小姐</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="電話" prop="phone" required>
                  <el-input v-model.trim="form.phone" placeholder="09xxxxxxxx" :disabled="isEditMode">
                    <el-select v-model="form.phoneCode" slot="prepend" style="width: 100px;">
                      <el-option label="+886" value="+886" />
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="備用電話">
                  <el-input v-model.trim="form.extraPhone" placeholder="請輸入備用電話">
                    <el-select v-model="form.extraPhoneCode" slot="prepend" style="width: 100px;">
                      <el-option label="+886" value="+886" />
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="標籤">
                  <el-select v-model="form.tags" multiple placeholder="請選擇" style="width: 100%;">
                    <el-option v-for="tag in tagList" :key="tag.id" :label="tag.title" :value="tag.id" />
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="24">
                <el-form-item label="Email" prop="email">
                  <el-input v-model="form.email" placeholder="Email" />
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="LINE ID">
                  <el-input v-model="form.lineId" placeholder="LINE ID" />
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="緊急聯絡人姓名">
                  <el-input v-model="form.emergencyName" placeholder="請輸入姓名" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label=" " class="gender-item">
                  <el-radio-group v-model="form.emergencyGender">
                    <el-radio label="male">先生</el-radio>
                    <el-radio label="female">小姐</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="緊急聯絡人電話">
                  <el-input v-model.trim="form.emergencyPhone" placeholder="請輸入緊急聯絡人電話">
                    <el-select v-model="form.emergencyPhoneCode" slot="prepend" style="width: 100px;">
                      <el-option label="+886" value="+886" />
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <div class="footer-actions">
              <el-button round @click="handleClose">取消</el-button>
              <el-button round type="primary" :loading="submitting" @click="tryToStoreMember">儲存</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CustomerCreatePartial',
  props: {
    show: { type: Boolean, default: false },
    editData: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      visible: false,
      submitting: false,
      tagList: [],
      form: this.initForm(),
      rules: {
        fullName: [{ required: true, message: '請輸入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '請輸入電話', trigger: 'blur' }, { pattern: /^09\d{8}$/, message: '格式不符', trigger: 'blur' }],
        email: [{ type: 'email', message: '格式錯誤', trigger: 'blur' }],
      },
    }
  },
  computed: {
    isEditMode() {
      return !!this.editData?.id
    },
  },
  watch: {
    show: {
      handler(val) {
        this.visible = val
        if (val) {
          this.fetchTags()
        }
      },
      immediate: true,
    },
    editData: {
      handler(val) {
        this.form = val && val.id ? { ...this.initForm(), ...val } : this.initForm()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    initForm() {
      return {
        fullName: '',
        gender: 'male',
        phoneCode: '+886',
        phone: '',
        extraPhoneCode: '+886',
        extraPhone: '',
        tags: [],
        email: '',
        lineId: '',
        emergencyName: '',
        emergencyGender: 'male',
        emergencyPhoneCode: '+886',
        emergencyPhone: '',
      }
    },
    async fetchTags() {
      try {
        this.tagList = await this.$store.dispatch('member/fetchTags')
      } catch (e) {
        console.error(e)
      }
    },
    handleClose() {
      this.$emit('update:show', false)
      this.$emit('close')
    },
    formatPayload() {
      const tagIds = this.form.tags.map((tag) => (typeof tag === 'object' ? tag.id : tag))
      return {
        id: this.editData?.id || null,
        phoneCode: this.form.phoneCode,
        phoneNumber: this.form.phone,
        fullName: this.form.fullName,
        gender: this.form.gender,
        email: this.form.email || null,
        lineId: this.form.lineId || null,
        tagIds: tagIds,
        extraInfos: {
          extraInfoPhone: [{ phoneCode: this.form.extraPhoneCode, phoneNumber: this.form.extraPhone }],
          extraInfoEmergency: [
            {
              phoneCode: this.form.emergencyPhoneCode,
              phoneNumber: this.form.emergencyPhone,
              fullName: this.form.emergencyName,
              gender: this.form.emergencyGender,
            },
          ],
        },
        billingInfo: {
          name: this.form.fullName,
          phone: this.form.phone,
          email: this.form.email,
          postcode: '',
          city: '',
          district: '',
          address: '',
        },
        shippingInfo: [],
        taxType: 'B2C',
        saveTaxInfo: 0,
      }
    },
    tryToStoreMember() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('欄位填寫未完整，請檢查紅框標示處')
          return false
        }
        this.doSubmit()
      })
    },
    async doSubmit() {
      this.submitting = true
      try {
        const payload = this.formatPayload()
        const res = await this.$store.dispatch('member/store', payload)
        this.$message.success(this.isEditMode ? '客戶資料已更新' : '已新增客戶')
        this.$emit('save', res.items)
        this.handleClose()
      } catch (err) {
        console.error('Submit failed', err)
      } finally {
        this.submitting = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
/* 側欄外層定位 */
.custom-drawer-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10; /* 高於原本 UI */
  display: flex;
  justify-content: flex-end;
}

/* 白色內容容器 */
.drawer-container {
  position: relative;
  width: 42%;
  height: 100%;
  background: #f9f9fb;
  box-shadow: -4px 0 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  z-index: 3001;
}

.drawer-header {
  padding: 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
  background: #f9f9fb;
  flex-shrink: 0;

  .close-btn {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 28px;
    margin-right: 15px;
    line-height: 1;
  }
  .drawer-title {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
  }
}

.drawer-content-scroll {
  padding: 30px;
  padding-bottom: 50px;
  flex: 1;
  overflow-y: auto;

  .gender-item {
    margin-top: 26px;
  }
}

.footer-actions {
  margin-top: 40px;
  padding-bottom: 40px;
  display: flex;
  gap: 15px;
  .el-button {
    flex: 1;
  }
}

/* 入場與退場動畫 */
.drawer-fade-enter-active,
.drawer-fade-leave-active {
  transition: opacity 0.3s;
  .drawer-container {
    transition: transform 0.3s ease;
  }
}
.drawer-fade-enter,
.drawer-fade-leave-to {
  opacity: 0;
  .drawer-container {
    transform: translateX(100%);
  }
}
</style>
